import { LIEN_LIST_DATA } from '@pages/DocumentAuditPage/modules/DocumentTaskDetail/components/DocumentReview/DocumentForms/ApproveForm/constants';
import { HistoryCardBase } from './HistoryCardBase';
import { DocumentHistoryItemCO } from '@domains/documents-review/interfaces/interfaces';

interface Props {
  item: DocumentHistoryItemCO;
  index: number;
}

const labels: Record<string, string> = {
  has_admin: 'Recibo admin.',
  admin_price: 'Valor admin.',
  construction_date: 'Fecha construcción del inmueble',
  area_type: 'Tipo de área',
  area: 'Área',
  baths: 'Baños',
  floor: 'Piso',
  has_garage: 'Garaje',
  garage: 'Cantidad de garajes',
  has_terrace: 'Balcón/Terraza (opc)',
  free_area: 'Área libre (opc)',
  liens: 'Gravámenes',
  lender_bank: 'Banco hipoteca (opcional)',
  comment: 'Comentario',
  years_old: 'Antigüedad',
};

export const areaTypeLabels: Record<string, string> = {
  private: 'Privada',
  built: 'Construida',
};

export const lienLabels: Record<string, string> = Object.fromEntries(
  LIEN_LIST_DATA.map(([label, value]) => [value, label])
);

export const HistoryCardCO = ({ item, index }: Props) => (
  <HistoryCardBase item={item} index={index} labels={labels} />
);
